import { RecentInteractionsLogDto } from "app/ApiClient";
import { LoadingState } from "types";

export interface InteractionLogState {
  loading: LoadingState;  
  errorMessage?: string;  
  deleteSuccessMessage?: string;  
  deleteLoading: LoadingState;
  recentInteractionLogs? : RecentInteractionsLogDto;
  recentInteractionsCount? : number;
  recentInteractionsCountStatus : LoadingState;
  recentInteractionLogsStatus: LoadingState;
}

export const initialInteractionLogsState: InteractionLogState = {  
  loading: LoadingState.idle,  
  deleteSuccessMessage: "",
  deleteLoading: LoadingState.idle,
  recentInteractionLogs: undefined,
  recentInteractionLogsStatus: LoadingState.idle,
  recentInteractionsCountStatus: LoadingState.idle,
};
